export const getPanelState = (open?: boolean) => {
  return open ? 'open' : 'closed';
};
